import React from 'react';
import { FileTextIcon, GiftIcon } from 'lucide-react';
import type { Bonus } from '../data/bonuses';
export function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="overflow-hidden rounded-2xl bg-white shadow-lg shadow-black/30" data-id="element-18" data-mp="2o5v6a6qvvyl2">
      <div className="flex items-center gap-3 border-b border-brand/10 px-4 py-3 md:px-5" data-id="element-19" data-mp="2t10wviv8e1fh">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-accent px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-brand-deep md:text-[11px]" data-id="element-20" data-mp="2x2md9e6z4xuf">
          <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-21" data-mp="25e2e2ejn2hee" />
          Bonus {bonus.number}
        </span>
        <h3 className="text-sm font-black uppercase leading-tight text-brand-deep md:text-base" data-id="element-22" data-mp="29dusv8zmljs7">{bonus.name}</h3>
      </div>
      <div className="px-4 py-4 md:px-5" data-id="element-23" data-mp="1hnyd6exu4vr3">
        <p className="text-sm leading-relaxed text-slate-600" data-id="element-24" data-mp="1hmx2wcon8daf">{bonus.summary}</p>
        <div className="mt-3 flex flex-wrap items-center justify-between gap-3" data-id="element-25" data-mp="1lp1pirgoc9nk">
          <p className="flex items-center gap-1.5 text-xs font-black uppercase tracking-wide text-brand" data-id="element-26" data-mp="1x1v70ucofix0">
            <FileTextIcon className="h-4 w-4" aria-hidden="true" data-id="element-27" data-mp="1s3a2iiqe6d2r" />
            {bonus.pages}
          </p>
          <p className="flex items-center gap-2" data-id="element-28" data-mp="1nbs2bww70giu">
            <span className="text-sm font-black text-slate-500 line-through decoration-red-600 decoration-2" data-id="element-29" data-mp="1nah3mbhltyyl">
              ${bonus.value} USD
            </span>
            <span className="rounded-md bg-brand px-3 py-1 text-xs font-black uppercase text-white" data-id="element-30" data-mp="1df6yhevwtbgl">Free</span>
          </p>
        </div>
      </div>
    </article>;
}